import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const localesModule = require.context(
    './modules',
    true,
    /\/locales\/[A-Za-z0-9-_,\s]+\.json$/i
  )

  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )

  const messagesModule = {}
  const messages = {}

  localesModule.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const data = localesModule(key)
      if (data) {
        messagesModule[locale] = {
          ...messagesModule[locale],
          ...data
        }
      }
    }
  })

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  Object.keys(messages).forEach(locale => {
    if (messagesModule[locale]) {
      messages[locale] = {
        ...messages[locale],
        ...messagesModule[locale]
      }
    }
  })

  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
